const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
const toggle = (selector, open) => {
  const panel = $(selector);
  panel?.classList.toggle("is-open", open);
  if (selector === "#MobileNav") $(".scrim")?.classList.toggle("is-open", open);
  document.body.classList.toggle("no-scroll", open && (selector === "#MobileNav" || selector === "#CartDrawer"));
  $("[data-toggle='" + selector + "']")?.setAttribute("aria-expanded", String(open));
};

document.addEventListener("click", async (event) => {
  const trigger = event.target.closest("[data-toggle]");
  if (trigger) {
    const target = trigger.dataset.toggle;
    toggle(target, !$(target)?.classList.contains("is-open"));
    return;
  }
  if (event.target.closest("[data-close]")) {
    toggle(event.target.closest("[data-close]").dataset.close, false);
    return;
  }
  const favorite = event.target.closest("[data-favorite]");
  if (favorite) {
    event.preventDefault();
    event.stopPropagation();
    const id = favorite.dataset.favorite;
    let saved = JSON.parse(localStorage.getItem("nish-favorites") || "[]");
    saved = saved.filter((item) => typeof item === "object");
    const exists = saved.some((item) => item.id === id);
    const card = favorite.closest("[data-product-id]");
    const analytics = readProductAnalytics();
    const item = {
      id,
      title: card?.dataset.productRawTitle || analytics?.title || $("h1")?.textContent.trim(),
      handle: card?.dataset.productHandle || analytics?.handle,
      url: card?.dataset.productUrl || location.pathname,
      price: card?.dataset.productPrice || $("#ProductPrice")?.textContent,
      amount: card?.dataset.productAmount || analytics?.price,
      image: card?.dataset.productImage || analytics?.image || $("#ProductMainImage")?.src,
      vendor: card?.dataset.productVendor || analytics?.vendor || "",
      sku: analytics && String(analytics.id) === String(id) ? analytics.sku : undefined,
      variantId: analytics && String(analytics.id) === String(id) ? analytics.variantId : undefined,
      productType: card?.dataset.productType || analytics?.type || "",
      tags: analytics && String(analytics.id) === String(id) ? analytics.tags || [] : [],
      variantTitle: analytics && String(analytics.id) === String(id) ? analytics.variantTitle : "",
      options: analytics && String(analytics.id) === String(id) ? analytics.options || [] : [],
    };
    const next = exists ? saved.filter((entry) => entry.id !== id) : [...saved, item];
    localStorage.setItem("nish-favorites", JSON.stringify(next));
    favorite.classList.toggle("is-active", !exists);
    favorite.setAttribute("aria-pressed", String(!exists));
    updateFavoriteCount(next.length);
    renderFavorites(next);
    if (!exists) trackFavorited(item);
    return;
  }
  const thumb = event.target.closest("[data-product-image]");
  if (thumb) {
    const colorButton = colorButtonForImage(thumb);
    if (colorButton && !colorButton.classList.contains("is-active")) {
      colorButton.parentElement.querySelectorAll("[data-option-value]").forEach((node) => node.classList.remove("is-active"));
      colorButton.classList.add("is-active");
      selectVariant();
      return;
    }
    showMainImage(thumb.dataset.productImage, $("img", thumb)?.alt, thumb.dataset.imageId);
    return;
  }
  const option = event.target.closest("[data-option-value]");
  if (option) {
    if (option.disabled) return;
    option.parentElement.querySelectorAll("[data-option-value]").forEach((node) => node.classList.remove("is-active"));
    option.classList.add("is-active");
    selectVariant();
    return;
  }
  const qty = event.target.closest("[data-cart-qty]");
  if (qty) {
    await changeCart(qty.dataset.cartQty, Number(qty.dataset.qty));
    return;
  }
  const remove = event.target.closest("[data-cart-remove]");
  if (remove) {
    await changeCart(remove.dataset.cartRemove, 0);
  }
});

document.addEventListener("submit", async (event) => {
  const form = event.target;
  if (form.matches(".promo-form, .newsletter")) {
    const email = form.querySelector("input[type=email]")?.value;
    if (email && /^\S+@\S+\.\S+$/.test(email)) {
      const source = form.classList.contains("promo-form") ? "Top Banner" : "Footer";
      withKlaviyo((sdk) => {
        sdk.identify({ email });
        sdk.track("Subscribed to Newsletter", { Source: source });
      });
      const listId = form.dataset.klaviyoList;
      if (listId) {
        event.preventDefault();
        $("[type=submit]", form).disabled = true;
        try {
          await subscribeToKlaviyoList(email, listId, source);
          const status = document.createElement("p");
          status.className = "form-status";
          status.setAttribute("role", "status");
          status.textContent = form.dataset.success;
          form.replaceChildren(status);
        } catch {
          form.submit();
        }
        return;
      }
    }
  }
  const productForm = event.target.closest("[data-product-form]");
  if (!productForm) return;
  event.preventDefault();
  const button = $("[type=submit]", productForm);
  button.disabled = true;
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(Object.fromEntries(new FormData(productForm))),
    });
    if (!response.ok) throw new Error("Unable to add to bag");
    const added = await response.json();
    const cart = await refreshCart();
    trackAddedToCart(cart, added);
    toggle("#CartDrawer", true);
  } finally {
    button.disabled = false;
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  resetProductZoom();
  $$(".is-open").forEach((node) => node.classList.remove("is-open"));
  document.body.classList.remove("no-scroll");
});

let resetProductZoom = () => {};

function setupProductZoom() {
  const frame = $("#ProductZoom");
  const img = $("#ProductMainImage");
  if (!frame || !img) return;
  const fine = window.matchMedia("(pointer: fine)").matches;
  if (!fine) {
    $(".zoom-controls", frame)?.remove();
    return;
  }
  const levels = [1, 1.75, 2.5];
  let zoom = 1;
  let origin = { x: 50, y: 50 };
  const zoomOut = $("[data-zoom-out]", frame);
  const zoomIn = $("[data-zoom-in]", frame);
  const apply = () => {
    img.style.transform = `scale(${zoom})`;
    img.style.transformOrigin = `${origin.x}% ${origin.y}%`;
    frame.classList.toggle("is-zoomed", zoom > 1);
    if (zoomOut) zoomOut.disabled = zoom === 1;
    if (zoomIn) zoomIn.disabled = zoom === levels[levels.length - 1];
  };
  const pointFromEvent = (event) => {
    const rect = frame.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    return {
      x: Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100)),
      y: Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100)),
    };
  };
  resetProductZoom = () => {
    zoom = 1;
    origin = { x: 50, y: 50 };
    apply();
  };
  frame.addEventListener("mousemove", (event) => {
    if (zoom === 1 || event.target.closest(".zoom-controls")) return;
    const point = pointFromEvent(event);
    if (!point) return;
    origin = point;
    apply();
  });
  frame.addEventListener("click", (event) => {
    if (event.target.closest(".zoom-controls")) return;
    const point = pointFromEvent(event);
    if (point) origin = point;
    zoom = zoom === 1 ? levels[levels.length - 1] : 1;
    apply();
  });
  zoomIn?.addEventListener("click", (event) => {
    event.stopPropagation();
    const index = levels.findIndex((level) => level >= zoom);
    zoom = levels[Math.min(levels.length - 1, (index === -1 ? 0 : index) + 1)];
    apply();
  });
  zoomOut?.addEventListener("click", (event) => {
    event.stopPropagation();
    const index = levels.findIndex((level) => level >= zoom);
    zoom = levels[Math.max(0, (index === -1 ? 0 : index) - 1)];
    apply();
  });
  apply();
}

function showMainImage(src, alt, imageId) {
  const main = $("#ProductMainImage");
  if (!main || !src) return;
  main.src = src;
  main.srcset = "";
  if (alt) main.alt = alt;
  $$(".product-thumb").forEach((node) => node.classList.toggle("is-active", Boolean(imageId) && node.dataset.imageId === String(imageId)));
  resetProductZoom();
}

function readVariants() {
  try {
    return JSON.parse($("#ProductVariants")?.textContent || "[]");
  } catch {
    return [];
  }
}

function colorOptionButtons() {
  const group = $$(".option").find((node) => /colou?r/i.test($("legend", node)?.textContent || ""));
  if (!group) return [];
  return $$("[data-option-value]", group).sort((a, b) => b.dataset.optionValue.length - a.dataset.optionValue.length);
}

function colorButtonForImage(thumb) {
  const alt = ($("img", thumb)?.alt || "").toLowerCase();
  if (!alt) return null;
  return colorOptionButtons().find((button) => alt.includes(button.dataset.optionValue.toLowerCase())) || null;
}

function showVariantImage(variant) {
  const image = variant.featured_image;
  if (!image) return;
  const thumb = image.id ? $(`.product-thumb[data-image-id="${image.id}"]`) : null;
  if (thumb) {
    showMainImage(thumb.dataset.productImage, $("img", thumb)?.alt, image.id);
    return;
  }
  if (image.src) showMainImage(image.src, image.alt, image.id);
}

function syncOptionAvailability() {
  const variants = readVariants();
  const groups = $$(".option");
  const selected = groups.map((group) => group.querySelector("[data-option-value].is-active")?.dataset.optionValue);
  groups.forEach((group, groupIndex) => {
    $$("[data-option-value]", group).forEach((button) => {
      const match = variants.find((variant) =>
        variant.options.every((optionValue, index) => (index === groupIndex ? optionValue === button.dataset.optionValue : optionValue === selected[index])),
      );
      button.disabled = !match?.available;
    });
  });
}

function readReturnLink() {
  const params = new URLSearchParams(location.search);
  const rawTo = params.get("backTo") || "";
  const rawLabel = (params.get("backLabel") || "").trim();
  const backTo = /^\/(?!\/)/.test(rawTo) ? rawTo : "";
  const backLabel = rawLabel && rawLabel.length <= 40 ? rawLabel : "";
  const fallback = $("#ProductBack")?.getAttribute("href") || "/collections/all";
  return { href: backTo || fallback, label: backLabel || "Shop" };
}

function applyReturnLink() {
  const link = $("#ProductBack");
  if (!link) return;
  const back = readReturnLink();
  link.href = back.href;
  const template = link.dataset.template || "← Back to __LABEL__";
  link.textContent = template.replace("__LABEL__", back.label);
}

function withBack(url, backTo, backLabel) {
  try {
    const parsed = new URL(url, location.origin);
    if (backTo) parsed.searchParams.set("backTo", backTo);
    if (backLabel) parsed.searchParams.set("backLabel", backLabel);
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return url;
  }
}

function stampCards(cards, backTo, backLabel) {
  cards.forEach((card) => {
    const link = $("a", card);
    if (link && card.dataset.productUrl) link.href = withBack(card.dataset.productUrl, backTo, backLabel);
  });
}

function applyProductBackLinks() {
  if (!$("#ProductBack")) return;
  const back = readReturnLink();
  stampCards($$(".recommendations .product-card"), back.href, back.label);
}
window.applyProductBackLinks = applyProductBackLinks;

function updateModelLine() {
  const story = $("#ProductStory");
  const line = $("#ProductModelLine");
  if (!story || !line) return;
  const colorIndex = Number(story.dataset.colorIndex);
  const groups = $$(".option");
  const color = colorIndex >= 0 ? groups[colorIndex]?.querySelector("[data-option-value].is-active")?.dataset.optionValue || "" : "";
  const height = story.dataset.productHandle === "splash-dress-tidal" && color === "Deep Pink Pattern" ? "5'11" : "5'10";
  const wearing = story.dataset.sizeValue || "";
  line.textContent = wearing ? `Model is ${height} and wearing Size ${wearing}` : `Model is ${height}`;
}

function selectVariant() {
  const form = $("[data-product-form]");
  if (!form) return;
  const selected = $$(".option").map((group) => group.querySelector("[data-option-value].is-active")?.dataset.optionValue);
  const variant = readVariants().find((entry) => entry.options.every((value, index) => value === selected[index]));
  if (!variant) return;
  $("[name=id]", form).value = variant.id;
  $("#ProductPrice").textContent = formatMoney(variant.price);
  const submit = $("[type=submit]", form);
  submit.disabled = !variant.available;
  submit.textContent = variant.available ? submit.dataset.available : submit.dataset.sold;
  showVariantImage(variant);
  const analytics = $("#ProductAnalytics");
  if (analytics) {
    const data = JSON.parse(analytics.textContent);
    data.variantId = variant.id;
    data.variantTitle = variant.title;
    data.options = variant.options;
    data.price = variant.price / 100;
    data.sku = variant.sku;
    if (variant.featured_image?.src) data.image = variant.featured_image.src;
    analytics.textContent = JSON.stringify(data);
  }
  syncOptionAvailability();
  updateModelLine();
  const params = new URLSearchParams(location.search);
  params.set("variant", String(variant.id));
  history.replaceState({}, document.title, `${location.pathname}?${params.toString()}`);
}

function formatMoney(cents) {
  return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
    style: "currency",
    currency: window.themeCurrency || "USD",
  }).format(cents / 100);
}

async function changeCart(line, quantity) {
  await fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ line: Number(line), quantity }),
  });
  await refreshCart();
}

async function refreshCart() {
  const cart = await fetch(window.Shopify.routes.root + "cart.js").then((response) => response.json());
  $$("[data-cart-count]").forEach((node) => {
    node.textContent = cart.item_count;
    node.hidden = !cart.item_count;
  });
  const body = $("#CartDrawerBody");
  if (body) {
    body.innerHTML = cart.items.length
      ? cart.items
          .map(
            (item, index) => `<div class="drawer-line"><img src="${item.image || ""}" alt=""><div><a href="${item.url}">${item.product_title}</a><p class="muted">${item.variant_title || ""}</p><p>${formatMoney(item.final_line_price)}</p><div class="qty"><button type="button" data-cart-qty="${index + 1}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-qty="${index + 1}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button></div></div><button class="icon-button" data-cart-remove="${index + 1}" aria-label="Remove">×</button></div>`,
          )
          .join("")
      : `<p class="empty">Your bag is empty.</p>`;
  }
  const total = $("#CartDrawerTotal");
  if (total) total.textContent = formatMoney(cart.total_price);
  syncCartProfile(cart);
  return cart;
}

function updateFavoriteCount(count) {
  $$("[data-favorite-count]").forEach((node) => {
    node.textContent = count;
    node.hidden = !count;
  });
}

function renderFavorites(items) {
  const grid = $("#FavoritesGrid");
  if (!grid) return;
  grid.innerHTML = items.length
    ? items
        .map(
          (item) => `<article class="product-card" data-product-id="${item.id}" data-product-title="${item.title}" data-product-url="${item.url}" data-product-price="${item.price}" data-product-image="${item.image}"><a href="${withBack(item.url, "/pages/join-the-newsletter?view=favorites", "Favorites")}"><div class="product-card-image"><img src="${item.image}" alt="${item.title}"><button class="favorite is-active" type="button" data-favorite="${item.id}" aria-pressed="true">♡</button></div><div class="product-card-meta"><span>${item.title}</span><span>${item.price}</span></div></a></article>`,
        )
        .join("")
    : `<div class="favorites-empty"><p>${grid.dataset.empty}</p><a class="button button--outline" href="${grid.dataset.shop}">Browse The Shop</a></div>`;
}

function withKlaviyo(callback, attempts = 20) {
  const sdk = window.klaviyo;
  if (sdk && typeof sdk.track === "function") {
    callback(sdk);
    return;
  }
  if (attempts <= 0) return;
  window.setTimeout(() => withKlaviyo(callback, attempts - 1), 250);
}

function readProductAnalytics() {
  const node = $("#ProductAnalytics");
  if (!node) return null;
  try {
    return JSON.parse(node.textContent);
  } catch {
    return null;
  }
}

const KLAVIYO_PRODUCT_ORIGIN = "https://nishniche.com";
const KLAVIYO_COMPANY_ID = "WpX3mZ";

async function subscribeToKlaviyoList(email, listId, source) {
  const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${KLAVIYO_COMPANY_ID}`, {
    method: "POST",
    headers: { "Content-Type": "application/vnd.api+json", revision: "2026-10-15" },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: "profile",
              attributes: { email, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } },
            },
          },
        },
        relationships: { list: { data: { type: "list", id: listId } } },
      },
    }),
  });
  if (!response.ok) throw new Error(`Klaviyo subscribe failed: ${response.status}`);
}

function absoluteUrl(url) {
  if (!url) return "";
  return url.startsWith("//") ? `https:${url}` : url;
}

function productPageUrl(handle) {
  return `${KLAVIYO_PRODUCT_ORIGIN}/products/${handle}`;
}

function checkoutUrl() {
  return new URL("checkout", location.origin + (window.Shopify?.routes?.root || "/")).href;
}

function dollars(cents) {
  const amount = Number(cents || 0) / 100;
  return Number(amount.toFixed(2));
}

function displayDollars(amount) {
  const number = typeof amount === "number" ? amount : Number.parseFloat(String(amount).replace(/[^0-9.]/g, ""));
  return Number.isFinite(number) ? `$${number.toFixed(2)}` : String(amount ?? "");
}

function klaviyoItem(product) {
  const price = Number(product.amount);
  const numericPrice = Number.isFinite(price) ? price : product.amount;
  return {
    Name: product.title,
    ProductID: String(product.id),
    VariantID: product.variantId ? String(product.variantId) : undefined,
    SKU: product.sku || undefined,
    ImageURL: absoluteUrl(product.image),
    URL: productPageUrl(product.handle),
    Handle: product.handle,
    Brand: product.vendor || "",
    Price: numericPrice,
    Metadata: {
      Brand: product.vendor || "",
      Price: numericPrice,
      ProductType: product.productType || "",
      Tags: product.tags || [],
    },
  };
}

function cartLineItem(line) {
  const price = dollars(line.final_price || line.price);
  return {
    ProductID: String(line.product_id),
    VariantID: String(line.variant_id),
    SKU: line.sku || undefined,
    ProductName: line.product_title,
    VariantName: line.variant_title || "",
    Quantity: line.quantity,
    ItemPrice: price,
    RowTotal: Number((price * line.quantity).toFixed(2)),
    ProductURL: productPageUrl(line.handle),
    ImageURL: absoluteUrl(line.image),
    ProductCategories: [],
    ProductType: line.product_type || "",
    Brand: line.vendor || "",
    SelectedOptions: (line.options_with_values || []).map((option) => ({ name: option.name, value: option.value })),
  };
}

function extraLineItem(line) {
  const price = dollars(line.final_price || line.price);
  return {
    title: line.product_title,
    url: productPageUrl(line.handle),
    image_url: absoluteUrl(line.image),
    price: displayDollars(price),
    quantity: line.quantity,
    product: {
      handle: line.handle,
      title: line.product_title,
      images: [{ src: absoluteUrl(line.image) }],
    },
  };
}

function trackAddedToCart(cart, added) {
  const lines = cart?.items || [];
  const page = readProductAnalytics();
  const sameProduct = page && String(page.id) === String(added.product_id);
  const handle = added.handle || (sameProduct ? page.handle : "");
  const addedPrice = dollars(added.final_price || added.price);
  const addedItem = klaviyoItem({
    id: added.product_id,
    title: added.product_title,
    handle,
    vendor: added.vendor,
    sku: added.sku,
    variantId: added.variant_id,
    amount: addedPrice,
    image: added.image,
    productType: added.product_type,
    tags: sameProduct ? page.tags || [] : [],
  });
  const cartItems = lines.map(cartLineItem);
  const extra = lines.length ? lines.map(extraLineItem) : [extraLineItem({ ...added, handle, quantity: added.quantity || 1 })];
  const cartValue = cartItems.length
    ? cartItems.reduce((sum, item) => sum + (typeof item.RowTotal === "number" ? item.RowTotal : 0), 0)
    : addedPrice * (added.quantity || 1);
  const destination = checkoutUrl();
  window.Shopify?.analytics?.publish?.("product_added_to_cart", {
    cartLine: {
      quantity: added.quantity || 1,
      cost: { totalAmount: { amount: addedPrice * (added.quantity || 1), currencyCode: window.themeCurrency || "USD" } },
      merchandise: {
        id: `gid://shopify/ProductVariant/${added.variant_id || added.id}`,
        title: added.variant_title,
        sku: added.sku,
        price: { amount: addedPrice, currencyCode: window.themeCurrency || "USD" },
        image: { src: added.image },
        product: {
          id: `gid://shopify/Product/${added.product_id}`,
          title: added.product_title,
          vendor: added.vendor,
          type: added.product_type,
          url: added.url,
        },
      },
    },
  });
  withKlaviyo((sdk) => {
    sdk.track("Added to Cart", {
      ...addedItem,
      $value: Number(cartValue.toFixed(2)),
      $event_id: `${cart?.token || added.variant_id || added.product_id}_${Date.now()}`,
      AddedItemProductName: added.product_title,
      AddedItemProductID: String(added.product_id),
      AddedItemVariantID: added.variant_id ? String(added.variant_id) : undefined,
      AddedItemSKU: added.sku || undefined,
      AddedItemCategories: [],
      AddedItemImageURL: absoluteUrl(added.image),
      AddedItemURL: productPageUrl(handle),
      AddedItemPrice: addedPrice,
      AddedItemQuantity: 1,
      CheckoutURL: destination,
      ItemNames: cartItems.length ? cartItems.map((item) => item.ProductName) : [added.product_title],
      $extra: { line_items: extra, items: extra, checkout_url: destination },
      Items: cartItems.length
        ? cartItems
        : [
            {
              ProductID: String(added.product_id),
              VariantID: added.variant_id ? String(added.variant_id) : undefined,
              SKU: added.sku || undefined,
              ProductName: added.product_title,
              VariantName: added.variant_title || "",
              Quantity: 1,
              ItemPrice: addedPrice,
              RowTotal: addedPrice,
              ProductURL: productPageUrl(handle),
              ImageURL: absoluteUrl(added.image),
              ProductCategories: [],
              Brand: added.vendor || "",
              SelectedOptions: sameProduct ? (page.options || []).map((value, index) => ({ name: `Option ${index + 1}`, value })) : [],
            },
          ],
    });
  });
}

function trackFavorited(item) {
  const amount = Number(item.amount);
  const built = klaviyoItem({ ...item, amount: Number.isFinite(amount) ? amount : item.amount });
  withKlaviyo((sdk) => {
    sdk.track("Favorited Item", {
      ...built,
      $extra: {
        items: [
          {
            url: productPageUrl(item.handle),
            title: item.title,
            image_url: built.ImageURL,
            price: displayDollars(Number.isFinite(amount) ? amount : item.price),
          },
        ],
      },
    });
  });
}

function syncCartProfile(cart) {
  if (!cart) return;
  withKlaviyo((sdk) => {
    const items = (cart.items || []).map((item) => ({
      url: productPageUrl(item.handle),
      title: item.product_title,
      image_url: absoluteUrl(item.image),
      price: displayDollars(dollars(item.final_price || item.price)),
    }));
    const itemCount = (cart.items || []).reduce((count, item) => count + item.quantity, 0);
    sdk.identify({
      latest_cart: { items, item_count: itemCount },
      latest_cart_item_count: itemCount,
    });
  });
}

function categorize(title, type) {
  const hay = `${title || ""} ${type || ""}`.toLowerCase();
  if (/(hat|scarf|scarves|bag|belt|earring|necklace|ring|bucket)/.test(hay)) return "Accessories";
  if (/(jumpsuit|romper|playsuit)/.test(hay)) return "Jumpsuits";
  if (/(dress|gown)/.test(hay)) return "Dresses";
  if (/(jacket|coat|outer|blazer)/.test(hay)) return "Jackets";
  if (/(top|tank|shirt|blouse|tee|smock|vest)/.test(hay)) return "Tops";
  if (/(skirt|pant|short|trouser|legging|bottom)/.test(hay)) return "Bottoms";
  return "Knits";
}

async function loadRemainingShopPages() {
  const grid = $("[data-shop-grid][data-shop-pages]");
  const pages = Number(grid?.dataset.shopPages || 1);
  if (!grid || pages < 2) return;
  const section = grid.closest(".shopify-section");
  const sectionId = section?.id.replace(/^shopify-section-/, "");
  if (!sectionId) return;
  for (let page = 2; page <= pages; page += 1) {
    const url = new URL(location.href);
    url.searchParams.set("page", String(page));
    url.searchParams.set("section_id", sectionId);
    const html = await fetch(url.toString()).then((response) => response.text());
    const doc = new DOMParser().parseFromString(html, "text/html");
    doc.querySelectorAll(".product-card").forEach((card) => grid.appendChild(card));
  }
}

function applyShopFilter() {
  const grid = $("[data-shop-grid]");
  if (!grid) return;
  const params = new URLSearchParams(location.search);
  const dedicated = params.get("category");
  const filter = params.get("filter");
  const active = dedicated || filter || "All";
  const filters = $("[data-shop-filters]");
  if (dedicated && filters) filters.hidden = true;
  filters?.querySelectorAll("a").forEach((link) => link.classList.toggle("is-active", link.dataset.category === active));
  const title = $("[data-shop-title]");
  if (title && grid.hasAttribute("data-shop-all")) title.textContent = active === "All" ? "Shop All" : `Shop ${active}`;
  const cards = $$(".product-card", grid);
  const visible = cards.filter((card) => {
    const category = categorize(card.dataset.productTitle, card.dataset.productType);
    const show = active === "All" || category === active;
    card.hidden = !show;
    return show;
  });
  if (grid.hasAttribute("data-shop-all") && active === "All") sortShopAll(grid, visible);
  if (grid.hasAttribute("data-shop-all")) {
    let backTo = location.pathname;
    if (dedicated) backTo += `?category=${encodeURIComponent(dedicated)}`;
    else if (filter) backTo += `?filter=${encodeURIComponent(filter)}`;
    stampCards(cards, backTo, active === "All" ? "Shop" : active);
  }
  const count = $("[data-shop-count]");
  if (count) count.textContent = `${visible.length} pieces`;
}

function sortShopAll(grid, cards) {
  const order = { Tidal: 0, Dresses: 1, Tops: 2, Bottoms: 3, Accessories: 4, Jumpsuits: 5, Knits: 6 };
  const pinned = ["force-2-hoody-scarf-x-binding", "force-1-hoody-scarf-x-embroidery", "black-shady-draped-pants", "pa-dam-kilted-short", "square-boy-shorts"];
  const beforeBag = ["the-moon-flower-dress", "bluebelle-reversible-tank-top"];
  const bucket = (card) => (card.dataset.tidal === "true" ? "Tidal" : categorize(card.dataset.productTitle, card.dataset.productType));
  const sorted = [...cards].sort((a, b) => {
    const pa = pinned.indexOf(a.dataset.productHandle);
    const pb = pinned.indexOf(b.dataset.productHandle);
    if (pa !== -1 || pb !== -1) {
      if (pa === -1) return -1;
      if (pb === -1) return 1;
      return pa - pb;
    }
    const ba = order[bucket(a)] ?? 99;
    const bb = order[bucket(b)] ?? 99;
    if (ba !== bb) return ba - bb;
    if (bucket(a) === "Dresses") return Number(b.dataset.created || 0) - Number(a.dataset.created || 0);
    return 0;
  });
  const moving = sorted.filter((card) => beforeBag.includes(card.dataset.productHandle));
  const rest = sorted.filter((card) => !beforeBag.includes(card.dataset.productHandle));
  const anchor = rest.findIndex((card) => card.dataset.productHandle === "sling-bag");
  if (anchor !== -1) rest.splice(anchor, 0, ...moving);
  rest.forEach((card) => grid.appendChild(card));
}

function captureEpik() {
  const value = new URLSearchParams(location.search).get("epik")?.trim();
  if (!value) return;
  document.cookie = `_epik=${encodeURIComponent(value)}; Max-Age=${60 * 60 * 24 * 30}; Path=/; SameSite=Lax`;
}

function setCardHover(card, on) {
  const photo = card.querySelector(".product-card-photo");
  const hover = card.querySelector(".product-card-hover");
  if (!photo || !hover) return;
  card.classList.toggle("is-hovered", on);
  photo.style.opacity = on ? "0" : "";
  hover.style.opacity = on ? "1" : "";
}

document.addEventListener("mouseover", (event) => {
  const card = event.target.closest?.(".product-card");
  if (!card) return;
  const previous = event.relatedTarget?.closest?.(".product-card");
  if (previous === card) return;
  setCardHover(card, true);
});
document.addEventListener("mouseout", (event) => {
  const card = event.target.closest?.(".product-card");
  if (!card) return;
  const next = event.relatedTarget?.closest?.(".product-card");
  if (next === card) return;
  setCardHover(card, false);
});

document.addEventListener("DOMContentLoaded", () => {
  captureEpik();
  const promo = $("#PromoBar");
  if (promo) {
    if (localStorage.getItem("nn_promo_banner_seen")) promo.remove();
    else window.setTimeout(() => { promo.hidden = false; }, 15000);
  }
  document.addEventListener("click", (event) => {
    if (!event.target.closest("[data-promo-dismiss]")) return;
    localStorage.setItem("nn_promo_banner_seen", "1");
    promo?.remove();
  });
  const favorites = JSON.parse(localStorage.getItem("nish-favorites") || "[]").filter((item) => typeof item === "object");
  updateFavoriteCount(favorites.length);
  $$("[data-favorite]").forEach((node) => node.classList.toggle("is-active", favorites.some((item) => item.id === node.dataset.favorite)));
  renderFavorites(favorites);
  const slides = $$(".hero-slide");
  if (slides.length > 1) {
    let index = 0;
    setInterval(() => {
      slides[index].classList.remove("is-active");
      index = (index + 1) % slides.length;
      slides[index].classList.add("is-active");
    }, 2000);
  }
  loadRemainingShopPages().finally(() => applyShopFilter());
  setupProductZoom();
  applyReturnLink();
  syncOptionAvailability();
  updateModelLine();
  applyProductBackLinks();
  if (window.themeCustomerEmail) {
    withKlaviyo((sdk) => sdk.identify({ email: window.themeCustomerEmail }));
  }
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cart) => syncCartProfile(cart))
    .catch(() => {});
  const product = readProductAnalytics();
  if (product) {
    window.Shopify?.analytics?.publish?.("product_viewed", {
      productVariant: {
        id: `gid://shopify/ProductVariant/${product.variantId}`,
        price: { amount: Number(product.price), currencyCode: product.currency },
        sku: product.sku,
        title: product.title,
        image: { src: product.image },
        product: {
          id: `gid://shopify/Product/${product.id}`,
          title: product.title,
          vendor: product.vendor,
          type: product.type,
          url: location.pathname,
        },
      },
    });
    withKlaviyo((sdk) => {
      const item = klaviyoItem({
        id: product.id,
        title: product.title,
        handle: product.handle,
        vendor: product.vendor,
        sku: product.sku,
        variantId: product.variantId,
        amount: Number(product.price),
        image: product.image,
        productType: product.type,
        tags: product.tags || [],
      });
      if (typeof sdk.trackViewedItem === "function") sdk.trackViewedItem(item);
      sdk.track("Viewed Product", item);
    });
  }
});
